import { getAuth } from 'firebase/auth';

export interface WabaPhone {
  id: string;
  display_phone_number: string;
  name: string;
  quality_rating: string;
  messaging_limit_tier: string;
}

export interface WabaInfo {
  id: string;
  name: string;
  phone_numbers: {
    data: WabaPhone[];
  };
}

export interface WabaProfile {
  about?: string;
  address?: string;
  description?: string;
  email?: string;
  profile_picture_url?: string;
  websites?: string[];
  vertical?: string;
}

const getHeaders = async () => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
};

export const fetchWabaInfo = async (): Promise<{ waba: WabaInfo; profile: WabaProfile }> => {
  const headers = await getHeaders();
  const res = await fetch('/api/whatsapp/waba/info', { headers });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to fetch WABA info');
  }
  return res.json();
};

export const updateWabaProfile = async (profile: Partial<WabaProfile>): Promise<void> => {
  const headers = await getHeaders();
  const res = await fetch('/api/whatsapp/waba/profile', {
    method: 'POST',
    headers,
    body: JSON.stringify(profile)
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to update profile');
  }
};
